export default "__VITE_ASSET__5a12a4db__"